var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpinningWand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eo777urdvrca1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca2",
    transform: "matrix(1.79583426079734 0 0 1.55111212861651 57.02334293794027 69.08377703487263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca3_to",
    transform: "translate(45.617000,35.245611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca3_ts",
    transform: "scale(0.800000,0.800000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca3",
    transform: "translate(-63.443981,-49.500313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eo777urdvrca5",
    d: "M65.533700,0.167727C66.204400,-0.242364,66.908600,0.463855,67.637900,0.274463C69.427200,1.736640,66.643500,4.279030,65.320100,2.766450C65.059900,1.986530,65.063300,0.864487,65.533700,0.167727Z",
    transform: "matrix(1 0 0 1 2.61245419044810 -17.43604729429031)",
    opacity: 0,
    fill: "rgb(0,0,0)",
    stroke: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eo777urdvrca7",
    d: "M49.374800,105.909000C50.018600,105.684000,50.740100,105.813000,51.280200,106.245000C51.495600,107.449000,50.775900,109.174000,49.441500,108.897000C47.846800,108.891000,48.239900,106.333000,49.374800,105.909000Z",
    transform: "matrix(1 0 0 1 0 7.47259169755300)",
    opacity: 0,
    fill: "rgb(0,0,0)",
    stroke: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca8_tr",
    transform: "translate(83.499401,107.775513) rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca8_ts",
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca8",
    transform: "translate(-83.499401,-107.775513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eo777urdvrca9",
    d: "M58.007800,99.124100C58.318000,98.717200,59.039900,98.889200,59.148000,99.431700C59.370100,100.591000,58.488000,101.507000,58.266200,102.587000C59.099300,103.235000,61.228700,103.191000,60.628800,104.806000C59.701300,105.861000,58.429600,104.871000,57.456600,104.469000C56.936100,105.308000,56.514600,106.339000,55.555300,106.688000C54.708800,105.733000,55.779400,104.462000,56.052600,103.461000C55.256100,102.867000,53.682900,102.393000,54.078700,101.022000C55.073200,100.706000,56.031400,101.129000,56.856800,101.695000C57.475300,100.972000,57.655600,99.994800,58.007800,99.124100Z",
    transform: "matrix(1 0 0 1 26.12454190448111 4.98172779836867)",
    fill: "rgb(0,0,0)",
    stroke: "none",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca10_tr",
    transform: "translate(29.977854,-10.265272) rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca10_ts",
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca10",
    transform: "translate(-29.977854,10.265272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eo777urdvrca11",
    d: "M58.696300,4.596180C60.655500,4.460910,60.013800,7.483360,59.894500,8.830450C61.026800,9.259100,62.729600,8.314350,63.310200,9.859630C62.512400,10.888100,61.068500,10.648300,59.959500,10.807800C59.665300,11.916500,59.877100,13.098000,59.564600,14.203300C59.412600,14.813200,58.616200,14.915200,58.302400,14.402900C57.591700,13.438700,58.141900,12.156000,57.898500,11.059800C57.090200,10.073800,54.570300,11.122200,54.119500,9.597720C55.190100,8.475250,56.770800,8.884890,58.105400,8.758040C58.411600,7.441830,57.701500,5.516530,58.696300,4.596180Z",
    transform: "matrix(1 0 0 1 -28.73699609492923 -19.92691119347464)",
    fill: "rgb(0,0,0)",
    stroke: "none",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eo777urdvrca13",
    d: "M95.947200,22.645900C96.831700,22.426500,98.422300,22.720200,98.005000,24.058500C98.283000,25.698900,96.395800,25.515400,95.518200,24.987000C95.274300,24.202900,94.934100,22.968400,95.947200,22.645900Z",
    transform: "matrix(1 0 0 1 0 -9.96345559673732)",
    opacity: 0,
    fill: "rgb(0,0,0)",
    stroke: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca14_tr",
    transform: "translate(108.943573,40.321768) rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca14_ts",
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca14",
    transform: "translate(-108.943573,-40.321768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eo777urdvrca15",
    d: "M88.342600,32.882800C90.214100,32.758300,88.307300,35.943000,88.702100,36.689500C89.901600,36.457400,90.932800,35.692300,92.084000,35.311700C92.741700,35.034800,93.138500,35.987000,92.766000,36.500000C92.027600,37.437100,90.769100,37.404000,89.872700,38.083600C90.324000,39.048200,91.487700,39.842500,90.918800,41.084600C89.832300,42.151900,88.947200,40.290400,88.081500,39.752600C87.792400,40.799600,87.708000,42.034300,86.868100,42.781000C85.492700,42.846500,85.925000,40.835000,85.760200,39.876200C84.935000,40.105700,84.017400,40.744800,83.215900,40.108400C82.907200,38.637500,84.576200,37.978600,85.507300,37.342700C84.992100,36.122400,83.361000,35.259600,83.599000,33.828800C84.824200,32.240300,85.872100,34.852500,86.967500,35.336400C87.158400,34.379000,87.462800,33.350100,88.342600,32.882800Z",
    transform: "matrix(1 0 0 1 20.89963352358491 2.49086389918433)",
    fill: "rgb(0,0,0)",
    stroke: "none",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eo777urdvrca17",
    d: "M25.199700,49.339000C26.274700,48.518900,26.444300,50.468900,26.500700,51.239400C26.078200,52.540400,24.380800,52.222000,23.492000,51.737700C23.030900,50.287100,24.382900,49.982600,25.199700,49.339000Z",
    transform: "matrix(1 0 0 1 0 -4.98172779836867)",
    opacity: 0,
    fill: "rgb(0,0,0)",
    stroke: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca18_tr",
    transform: "translate(17.944385,78.248875) rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca18_ts",
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca18",
    transform: "translate(-17.944385,-78.248875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eo777urdvrca19",
    d: "M27.126600,70.343900C27.373900,70.055600,27.965900,70.209100,27.910900,70.655000C28.038200,72.427100,26.904600,73.871200,26.431100,75.484400C27.876400,75.394900,29.208200,74.331500,30.658300,74.638500C30.799700,76.651600,27.634300,76.117000,26.879600,76.959200C27.346100,78.142500,28.406200,79.291200,28.282200,80.591000C27.103500,81.768000,26.565200,79.352600,25.856700,78.638800C25.472600,79.555000,25.671500,81.067900,24.505600,81.318900C23.036100,80.386700,24.559800,78.695500,24.467000,77.370900C23.288600,77.544600,21.835500,80.096200,20.900600,78.269500C21.128900,76.650000,22.864300,76.192300,24.043900,75.592600C23.438500,74.484600,22.807400,73.239200,23.029600,71.901800C24.429300,71.158700,24.597200,73.393500,25.297500,74.183700C25.978600,72.949200,26.259400,71.433600,27.126600,70.343900Z",
    transform: "matrix(1 0 0 1 -7.83736257134434 2.49086389918433)",
    fill: "rgb(0,0,0)",
    stroke: "none",
    strokeWidth: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca20_tr",
    transform: "translate(21.652274,130.334346) rotate(-11.368462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca20_ts",
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca20",
    transform: "translate(-23.398504,-130.821750)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eo777urdvrca21",
    d: "M48.430218,2.882732C61.197569,-39.318487,106.426876,-5.651931,106.785817,-0.017386L40.998951,105.608582L-10.188483,89.767350L48.430218,2.882732Z",
    transform: "matrix(0.17873892229795 -0.00033343313338 0.00044320134164 0.23758085875598 60.15568597703257 20.83828989575937)",
    fill: "rgb(255,255,255)",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "eo777urdvrca22",
    d: "M59.580100,36.890300C62.868900,30.553700,64.949300,23.445500,68.905700,17.513700C70.094600,15.715400,72.316900,15.649200,74.162000,15.699500C75.858700,15.633900,77.102800,17.023900,78.552900,17.729700C79.733400,18.408300,79.514900,19.914400,79.821100,21.090300C79.059800,23.520100,77.806100,25.729100,76.658900,27.967800C75.022600,32.656300,72.425400,36.879400,70.702600,41.502000L69.723700,43.423900C67.922900,47.148600,66.140200,49.891700,64.625600,53.780600L62.081200,59.221100C59.987400,65.124700,56.808100,70.577000,54.323300,76.348600C51.992100,80.678100,47.009600,91.976500,44.624500,96.281200C43.341700,99.170100,42.500000,100.719000,41.055700,104.143000C39.668400,107.433000,38.500000,109.419000,37.762300,111.228000C34.741000,118.635000,31.078600,125.707000,27.634900,132.867000C26.655500,133.802000,26.582600,135.885000,25.034600,135.962000C22.474700,135.884000,19.316700,134.691000,18.683600,131.692000C21.965500,122.662000,25.976500,113.948000,29.799600,105.176000C31.299300,101.826000,32.590100,98.333800,34.228800,95.038100C38.196500,85.828300,48,64.218800,48,64.218800C48,64.218800,50.084800,59.186800,50.993700,57.239400C52.493300,53.738700,55.512200,46.179200,56.924200,42.959600C57.475600,41.702300,58.024400,40.450800,58.587000,39.220300L59.580100,36.890300ZM60.390300,41.275200C63.470700,34.032200,66.934800,26.928300,69.673900,19.471400L69.678200,19.463500C70.198600,18.508300,70.805200,17.394900,71.916900,17.208900C74.099200,16.813800,76.670500,17.392900,77.915200,19.518700C78.329000,20.152100,77.731500,20.768700,77.255600,21.086200C75.339200,21.238300,73.334000,20.526700,71.947400,19.090500C71.338200,19.012900,70.751000,19.852900,71.205100,20.408900C72.264500,22.422100,74.495900,23.255600,76.482500,23.572500C73.471100,30.065500,70.432400,36.601900,67.400300,43.094000C65.127700,44.555100,61.796100,43.641200,60.390300,41.275200Z",
    clipRule: "evenodd",
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "eo777urdvrca23",
    display: "none",
    d: "M29.288530,97.792676C35.693687,122.496596,61.090917,128.798881,74.836312,112.029340C85.867415,98.571440,83.376521,83.618218,80.173943,75.362843C76.971364,67.107368,69.498681,55.705536,58.111736,53.929891C46.794678,52.165012,46.002787,63.188129,53.129947,67.886232C61.670156,73.515622,78.457064,76.713581,89.183068,68.366791C104.094234,53.089486,93.900721,37.841811,89.546573,35.940011",
    transform: "matrix(0.68540327077251 0.85234051713782 0.74001518847022 -0.59507769535825 -38.47682647878908 40.28558380859609)",
    fill: "none",
    stroke: "rgb(0,0,0)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDashoffset: -229.1,
    strokeDasharray: 229.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "eo777urdvrca24_to",
    transform: "translate(60.674093,27.781640)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eo777urdvrca24",
    d: "M-13.176594,2.168101C-13.176594,-0.672845,-5.060873,-2.975886,4.950375,-2.975886C14.961623,-2.975886,23.077344,-0.672845,23.077344,2.168101C23.077344,5.009047,14.961623,7.312088,4.950375,7.312088C-5.060873,7.312088,-13.176594,5.009047,-13.176594,2.168101Z",
    transform: "rotate(19.407281) scale(1.837494,-1.198138) translate(-1.258908,-2.075953)",
    fill: "rgb(84,131,204)",
    fillOpacity: 0,
    stroke: "rgb(0,0,0)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDashoffset: 220,
    strokeDasharray: 40
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eo777urdvrca25",
    display: "none",
    d: "M-4.299192,1.799661C-4.299192,0.419209,-1.093020,-0.699869,2.861993,-0.699869C6.817007,-0.699869,10.023179,0.419209,10.023179,1.799661C10.023179,3.180114,6.817007,4.299192,2.861993,4.299192C-1.093020,4.299192,-4.299192,3.180114,-4.299192,1.799661Z",
    transform: "matrix(1.73308807806154 0.61056421521468 0.39811844682625 -1.13006022406399 53.02215527885556 55.14634290432929)",
    fill: "rgb(84,131,204)",
    fillOpacity: 0,
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDashoffset: 29,
    strokeDasharray: 30
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpinningWand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "spinning-wand.93ffb1a8c0c92c60d2f89714bed5e4d7.svg";